<template>
    <div>
        <h1>OTA TEST PAGE</h1>
        <div class="container">
            <div class="row">
                <div class="col">
                    <p class="install-copy">Vehicle software installation will occur between 3:00-5:00AM. During this time, some connected services including safety services will not be available.</p>
                </div>
            </div>
            <div class="row">
                <div class="btn btn-install" v-on:click="agreeClick">Agree and Install</div>
                <div class="btn btn-uninstall my-3" v-on:click="disagreeClick">Disagree</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ota",
    methods: {
        agreeClick: function(){
            alert("I agree!")
            window.location = "com.toyota.oneapp://oauthcallback"
        },
        disagreeClick: function(){
            alert("I do not agree!!!!")
            window.location = "com.toyota.oneapp://oauthcallback"
        }
    }
}
</script>

<style>
    .btn-install {
        height: 56px;
        background: #EB0A1E;
        border-radius: 3px;
        color:white;
    }
    .btn-uninstall {
        height: 56px;
        color: #EB0A1E;
        border: 1px solid #EB0A1E;
        box-sizing: border-box;
        border-radius: 3px;
    }
    .install-copy {
        /* text / caption 2 */
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        /* or 143% */
        /* color / black / 03 medium */
        color: #7D7D83;
    }
</style>